import type { ReactNode } from "react";
import { Card } from "@/app/admin/_common/ui/card";
import { Mail, Phone, AtSign, Tag } from "lucide-react";

function renderIntake(intake: number, intake_method: string) {
  if (intake === 16) return "Stripe";
  const waitlist = [1, 2, 3, 8, 4, 5, 6, 7, 9, 13, 14];
  if (waitlist.includes(intake)) return "Waitlist";
  return intake_method;
}

function Row({ icon: Icon, children }: { icon: typeof Mail; children: ReactNode }) {
  return (
    <div className="flex min-w-0 items-center gap-2 text-[15px] text-foreground sm:text-[13px]">
      <Icon className="size-4 flex-none text-muted-foreground sm:size-3.5" />
      <span className="truncate">{children}</span>
    </div>
  );
}

export default function GuestContactCard({ guest }: { guest: any }) {
  return (
    <Card className="rounded-none border-0 px-2 py-4 shadow-none md:rounded-md md:border md:px-4">
      <div className="mb-5 text-[16px] font-semibold text-foreground sm:mb-3 sm:text-[13.5px]">Details</div>

      <div className="grid grid-cols-1 gap-y-3 sm:grid-cols-2 sm:gap-y-5">
        <Row icon={Mail}>
          {guest.email ? (
            <a href={`mailto:${guest.email}`} className="hover:underline">
              {guest.email}
            </a>
          ) : (
            "—"
          )}
        </Row>
        <Row icon={Phone}>{guest.phone || "—"}</Row>
        <Row icon={AtSign}>{guest.instagram || "—"}</Row>
        <Row icon={Tag}>{renderIntake(guest.intake, guest.intake_method)}</Row>
      </div>
    </Card>
  );
}
